// removed by extract-text-webpack-plugin
module.exports = {"featureSection":"src-components-Features----Features-module---featureSection---2gseI","featureBox":"src-components-Features----Features-module---featureBox---12NmR","alternate":"src-components-Features----Features-module---alternate---QSq60","featureImageBox":"src-components-Features----Features-module---featureImageBox---1IKD4","credit":"src-components-Features----Features-module---credit---3jVue","featureFullscreenBackground":"src-components-Features----Features-module---featureFullscreenBackground---3jxAv","innerBox":"src-components-Features----Features-module---innerBox---3vwCz"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Features/Features.module.scss
// module id = 141
// module chunks = 221374088121123